import { CatalogProduct } from "src/lib/services/catalog/types";
import { OptionRenderingField } from "src/lib/services/util/optionRendering";
import { KeyValue } from "src/lib/util/toKeyValue";

export const findMatchingVariant = ({
  product,
  optionFilters,
  optionMatchConfigs,
  parentOptions,
}: {
  product: CatalogProduct | null | undefined;
  optionFilters: KeyValue[];
  optionMatchConfigs: OptionRenderingField[];
  parentOptions: { name: string; value: string }[];
}) => {
  if (!product || !product.variants) return undefined;

  if (
    optionFilters.length === 0 &&
    optionMatchConfigs.length === 0 &&
    product.variants[product.defaultVariant]?.available
  ) {
    return product.variants[product.defaultVariant];
  }

  const filteredVariants = Object.values(product.variants).filter(
    (variant) =>
      variant.available &&
      optionFilters.every((filter) => {
        const variantOption = variant.selectedOptions.find(
          (option) => option.name === filter.key
        );

        return variantOption && variantOption.value === filter.value;
      })
  );

  return filteredVariants.find((variant) =>
    optionMatchConfigs.every((config) => {
      const matchName = config.label || config.name;
      const parentOption = parentOptions.find(
        (option) => option.name === matchName
      );
      const variantOption = variant.selectedOptions.find(
        (option) => option.name === config.name
      );

      return (
        parentOption &&
        variantOption &&
        // Choose mapping if provided, otherwise just check for equality
        (config.mappings[parentOption.value]
          ? config.mappings[parentOption.value] === variantOption.value
          : parentOption.value === variantOption.value)
      );
    })
  );
};
